module.exports = __webpack_public_path__ + "static/media/bg.abaa0fd0.png";